<template>
    <HeaderAdmin />
    <div class="main_bottom_box">
        <SidebarAdmin />
        <AdminEmployeeLeaveRecord />
    </div>
</template>
<script>
import { createLocal } from 'the-storages'
import { BASE_URL } from "../config";
import axios from "axios";

const mirror = createLocal()
const storage = mirror._prx


import HeaderAdmin from "../components/AdminDashboard/HeaderAdmin.vue";

import SidebarAdmin from "../components/AdminDashboard/SidebarAdmin.vue";

import AdminEmployeeLeaveRecord from "../components/AdminDashboard/AdminEmployeeLeaveRecord.vue";


export default {
    name: 'AdminLeaveRecord',
    components:{
        HeaderAdmin,
        SidebarAdmin,
        AdminEmployeeLeaveRecord
    },
    data() {
        return {
            storageData: mirror,
            storage: storage,
        }
    },
    methods :{

    },
    async created(){
        this.userName = mirror.USERNAME
   },
    beforeRouteEnter(to, from, next) {
    //console.log(storage.get('TOKEN'));
        if (storage.get('TOKEN')) {
            next();
        }
        else {
            next('/');
        }
    }
}
</script>
<style scoped>
</style>